import type { TOC } from '@ember/component/template-only';
import SettingsRecommendationsRollingReferenceRates from 'lumen/components/settings/recommendations/rolling-reference-rates';
import type HotelSettingsRecommendationsRollingReferenceRatesRoute from 'lumen/routes/hotel/settings/recommendations/rolling-reference-rates';
import type { ModelFrom } from 'lumen/utils/routes';

interface HotelSettingsRecommendationsRollingReferenceRatesSignature {
  Args: {
    controller: unknown;
    model: ModelFrom<HotelSettingsRecommendationsRollingReferenceRatesRoute>;
  };
}

<template>
  <SettingsRecommendationsRollingReferenceRates @model={{@model}} />
</template> satisfies TOC<HotelSettingsRecommendationsRollingReferenceRatesSignature>;
